export default __webpack_public_path__ + "static/media/openSeaIcon.f2208d74.svg";